import React from "react";
import "../styles/Products.css";

const Products: React.FC = () => {
  return (
    <section id="products" className="products">
      <div className="container">
        <h2>Our Brands</h2>
        <div className="product-grid">
          <a
            href="https://banatindia.com"
            target="_blank"
            rel="noopener noreferrer"
            className="product-item"
          >
            <img src="/images/banat1.png" alt="Banat" />
            <h3>Banat</h3>
            <p>
              Personal Care & Hygiene Trusted brand for toothbrushes, grooming
              tools, and cleaning products—exported widely to Europe for daily
              essentials.
            </p>
          </a>
          <a
            href="https://vinsatoothbrush.com"
            target="_blank"
            rel="noopener noreferrer"
            className="product-item"
          >
            <img src="/images/vinsa.png" alt="Vinsa" />
            <h3>Vinsa</h3>
            <p>
              Modern Fashion & Lifestyle Stylish toothbrushes that blend comfort
              and contemporary design—crafted for today's global fashion trends.
            </p>
          </a>
          <a
            href="https://ottomanmitten.com"
            target="_blank"
            rel="noopener noreferrer"
            className="product-item"
          >
            <img src="/images/ottoman logo png.png" alt="Ottoman Mitten" />
            <h3>Ottoman Mitten</h3>
            <p>
              Rooted in centuries of Ottoman tradition, Ottoman Mitten combines
              heritage and modern craftsmanship. We offer luxurious bath mittens
              made from finest cocoon silk, trusted for over 400 years.
            </p>
          </a>
          <a
            href="https://guchdoors.com"
            target="_blank"
            rel="noopener noreferrer"
            className="product-item"
          >
            <img src="/images/guch doors.png" alt="Guch Doors" />
            <h3>Guch Doors</h3>
            <p>
              Premium Doors for Modern Spaces High-quality wooden and designer
              doors crafted for durability, style, and security—trusted across
              residential and commercial projects.
            </p>
          </a>
          <a
            href="https://parwahconfectionery.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="product-item"
          >
            <img src="/images/parw.png" alt="ParWah's Confectionery" />
            <h3>ParWah's Confectionery</h3>
            <p>
              Premium Confectionery & Sweet Treats Crafted with traditional recipes
              and modern techniques, ParWah's Confectionery delivers exceptional
              quality sweets and confectionery products for every celebration.
            </p>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Products;
